import { cn } from "@/lib/utils";

interface CitationChipProps {
  label: string;
  onClick?: () => void;
  className?: string;
}

export function CitationChip({ label, onClick, className }: CitationChipProps) {
  return (
    <button
      type="button"
      className={cn(
        "bg-muted px-2.5 py-1 text-xs text-muted-foreground transition-colors",
        "no-touch:hover:bg-border",
        "dark:bg-muted dark:text-muted-foreground dark:no-touch:hover:bg-muted/80",
        className
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
